import Vue from 'vue'
import router from '../router'
import store from '../store'

const install = Vue => {
  Vue.prototype.openDialog = async ({ name, ...extend }) => {
    if (name && typeof name === 'string') {
      let Dialog = await loadDialog(name, extend)
      let dialog = new Dialog({
        router,
        store
      })
      document.body.appendChild(dialog.$mount().$el)
    }
  }

  async function loadDialog (path, extend) {
    try {
      const dialogModule = await import('../pages' + path)
      let dialogBase = Vue.extend({
        data () { return { visible: false } },
        watch: {
          visible (val) {
            if (val) return
            const timeout = setTimeout(() => {
              clearTimeout(timeout)
              document.body.removeChild(this.$el)
              this.$destroy()
            }, 300)
          }
        },
        mounted () {
          this.visible = true
        },
        destroyed () {
          // 重置vm.$data
          // 销毁vm并不会重置data，需要手动重置
          if (!dialogModule.default.data) return
          const originData = dialogModule.default.data.apply(this)
          Object.assign(this.$data, originData)
        },
        methods: {
          close () {
            this.visible = false
          }
        }
      })
      let dialog = dialogBase.extend(dialogModule.default)
      if (extend) {
        dialog = dialog.extend({
          data: function () {
            return extend.data || {}
          },
          methods: extend.methods || {}
        })
      }
      return dialog
    } catch (err) {
      // console.error(`${path}-对话框不存在`)
    }
  }
}

Vue.use({ install })
